(function () {
  'use strict';

  if (typeof window.narika === 'undefined') {
    var narika = function () {
    };

    if (typeof exports !== 'undefined') {
      exports.narika = narika;
    }

    if (typeof window !== 'undefined') {
      window.narika = narika;
    } else if (typeof global !== 'undefined') {
      global.narika = narika;
    }
  }
  var narika = window.narika;

  narika.common = {
    SUCCESS: 200,
    sendPost: function (action, data, newwin) {

      var targetDocument = document;
      if (newwin != null) {
        targetDocument = newwin.document;
        targetDocument.open();
        targetDocument.write("<html>");
        targetDocument.writeln("<body></body>");
        targetDocument.write("</html>");
        targetDocument.close();
      }

      var form = targetDocument.createElement("form");
      form.setAttribute("action", action);
      form.setAttribute("method", "post");
      form.style.display = "none";
      targetDocument.body.appendChild(form);

      if (data !== undefined) {
        for (var paramName in data) {
          var input = targetDocument.createElement('input');
          input.setAttribute('type', 'hidden');
          input.setAttribute('name', paramName);
          input.setAttribute('value', data[paramName]);
          form.appendChild(input);
        }
      }
      form.submit();
    },
    sendGet: function (action, data) {
      var url = action;
      var count = 0;
      if (data !== undefined && data != null) {
        for (var paramName in data) {
          if (count == 0) {
            url += '?';
          }
          url += paramName + '=' + encodeURIComponent(data[paramName]);
          count++;
        }
      }
      window.location.href = url;
    },
    callRestApi: function (url, methodType, params, callback,
      callbackParams, callback_error, isAsync) {
      if (isAsync == undefined || isAsync == null) {
        isAsync = true;
      }

      var ajaxParam = {
        async: isAsync,
        dataType: 'json',
        progress: function (ev) {
          var rate;
          var tani;
          if (ev.lengthComputable) {
            rate = Math.round(ev.loaded / ev.total) * 100;
            tani = ' %';
          } else {
            rate = Math.round(ev.loaded);
            tani = ' bytes';
          }
        },
        xhr: function () {
          // add event the Progress for XHR
          var xhr = $.ajaxSettings.xhr();
          xhr.addEventListener("progress", this.progress);
          return xhr;
        },
        error: function (xhr, status, err) {
          var errmsg = 'XMLHttpRequest = ' + xhr.status
            + ', textStatus = ' + status + ', errorThrown ='
            + err.message;
          console.log(errmsg);
          if (callback_error != undefined && callback_error != null) {
            callback_error(errmsg);
          } else if (callback != undefined && callback != null) {
            callback(null, callbackParams);
          }
        },
        success: function (data) {
          if (callback != undefined && callback != null) {
            callback(data, callbackParams);
          }
        }
      };

      if ('GET' == methodType) {
        if (params != undefined && pramas != null) {
          ajaxParam['data'] = params;
        }

        ajaxParam['url'] = url;
        ajaxParam['type'] = 'GET';

      } else {

        if (params instanceof FormData) {
          ajaxParam['contentType'] = false;
          ajaxParam['processData'] = false;
        }
        ajaxParam['url'] = url;
        ajaxParam['type'] = 'POST';
        if (params != undefined && params != null) {
          ajaxParam['data'] = params;
        }

        if ('JSON' == methodType) {
          ajaxParam['contentType'] = "application/json; charset=utf-8";
        }
      }

      return $.ajax(ajaxParam);
    },
    getUrlGetParam: function (name) {
      var url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    removeHTMLTagAndNR: function (content) {
      content = $(content).text();
      content = content.replace(/\r?\n/g, "");
      return content;
    },
    cutSentences(text, number, lastChar) {
      var result = text;
      if (text.length > number) {
        if (lastChar === undefined || lastChar == null) {
          lastChar = '';
        }
        result = text.substr(0, number) + lastChar;
      }
      return result;
    },
    formatJapaneseYen: function (price) {
      return Number(price).toLocaleString('ja-JP', { "style": "currency", "currency": "JPY" });
    },
    escapeHTML: function (text) {
      if (typeof text !== 'string') {
        return text;
      }
      return text.replace(/[&'`"<>]/g, function (match) {
        return {
          '&': '&amp;',
          "'": '&#x27;',
          '`': '&#x60;',
          '"': '&quot;',
          '<': '&lt;',
          '>': '&gt;',
        }[match]
      });
    },
    saveInStorage: function (key, value) {
      var setjson = JSON.stringify(value);
      sessionStorage.setItem(key, setjson);
    },
    removeInStorage: function (key) {
      sessionStorage.removeItem(key);
    },
    loadFromStorage: function (key) {
      try {
        var jsonStr = sessionStorage.getItem(key);
        if (jsonStr == null || '{}' == jsonStr) {
          return null;
        }
        var obj = JSON.parse(jsonStr);
        return obj;
      } catch (error) {
        console.log(error);
      }
      return null;
    },
    encodeBase64Utf8: function (str) {
      return btoa(unescape(encodeURIComponent(str)));
    },
    decodeBase64Utf8: function (str) {
      return decodeURIComponent(escape(atob(str)));
    },
    trim: function (str) {
      if (str != null) {
        return str.replace(/^[s|　]+|[s|　]+$/g, '');
      }
      return null;
    },
  };

  module.exports = narika;

})();